<template>
  <div class="chats">
    <nav-bar></nav-bar>
    <div class="columns">
      <chat-selector class="chat-selector column is-one-fifth" :isBot="isBotSelected" v-on:changeChat="changeChat"
        v-on:toggleAgent="toggleAgent" :chatId="chatId" v-on:refresh="refresh"/>
      <chat class="column" :chatId="chatId" :isBot="isBotSelected" />
      <chat-info class="column is-one-fifth" :chatId="chatId" :isBot="isBotSelected" v-on:toggleAgent="toggleAgent" />
    </div>
  </div>
</template>

<script>
import ChatSelector from './ChatSelector'
import Chat from './Chat'
import ChatInfo from './ChatInfo'

export default {
  components: {
    ChatSelector, Chat, ChatInfo
  },
  props: { userId: Number },
  data () {
    return {
      chatId: null,
      isBotSelected: true
    }
  },
  mounted () {
    this.chatId = parseInt(this.$route.params.chat)
  },
  methods: {
    changeChat (id) {
      this.chatId = id
    },
    toggleAgent (chatId = null) {
      this.isBotSelected = !this.isBotSelected
      this.chatId = chatId
    },
    refresh () {
      this.toggleAgent(parseInt(this.$route.params.chat))
    }
  }
}
</script>

<style>
.chats {
  overflow-y: hidden;
}
  .chats .columns {
    margin: 0 !important;
    padding: 0 !important;
    max-height: 92vh;
  }

  .chats .chat-selector-container >::-webkit-scrollbar,
  .chats .chat-info-container ::-webkit-scrollbar {
    display: none;
  }

  .chats .columns .chat-selector.column {
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Chats/Chats.vue